export const openModal = ({ commit }, data) => {
    const {
        name,
        payload = null,
    } = data;

    commit('openedModal', name);
    commit('openedModalPayload', payload);
};